/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const CustomerType = {
    Company: 'company',
    Person: 'person'
};
export function instanceOfCustomerType(value) {
    for (const key in CustomerType) {
        if (Object.prototype.hasOwnProperty.call(CustomerType, key)) {
            if (CustomerType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function CustomerTypeFromJSON(json) {
    return CustomerTypeFromJSONTyped(json, false);
}
export function CustomerTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CustomerTypeToJSON(value) {
    return value;
}
export function CustomerTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
